import MuiGrid, { GridProps } from '@mui/material/Grid';
import React from 'react';

export type GridV2Props = GridProps;

export const GridV2 = (props: GridV2Props) => {
  return <MuiGrid {...props} />;
};
